module.exports = __webpack_public_path__ + "img/linkedin-small.1b18d461.png";